import * as React from "react";
import { useState } from "react";
import { invitePatientToCreateAccount, PatientAndAccountInformation } from "../commons/model/patient/PatientInfo";
import LoadingSpinner from "../flow/utils/LoadingSpinner";
import EntitySettingsId from "../commons/model/EntitySettingsId";
import TextAction from "../commons/components/action/TextAction";

export interface InvitationConfiguration {
  accountCreationInvitationURL: string;
  currentDoctorUid: EntitySettingsId;
}

interface InvitationState {
  loading: boolean;
  error: boolean;
}

export default function PatientAccountInviter({
  inviter,
  patientContactInfoUid,
  invitationConfiguration,
}: {
  inviter: PatientAndAccountInformation;
  patientContactInfoUid: string;
  invitationConfiguration?: InvitationConfiguration;
}) {
  const [invitationState, setInvitationState] = useState<InvitationState>({
    loading: false,
    error: false,
  });

  const invitePatient = async (inviter) => {
    setInvitationState((state) => ({
      ...state,
      loading: true,
    }));
    try {
      await invitePatientToCreateAccount(
        invitationConfiguration.accountCreationInvitationURL,
        patientContactInfoUid,
        invitationConfiguration.currentDoctorUid,
        inviter.contactInfoUid
      );
      setInvitationState({
        loading: false,
        error: false,
      });
    } catch (e) {
      setInvitationState({
        loading: false,
        error: true,
      });
    }
  };

  return inviter.hasAccount ? (
    <>
      <i className="ic_check_circled" />
      {i18n["Page.PatientManagement.Profile.Account.Created"]}
    </>
  ) : (
    <div className="link-container">
      <>
        <span>
          {i18n["Page.PatientManagement.Profile.Account.NotActivated"]}
          {inviter.invitationSent ? (
            <> ({i18n["Page.PatientManagement.Profile.Account.EmailSent"]})</>
          ) : (
            ""
          )}
        </span>
      </>
      <TextAction
        id={"send-activation-link"}
        icon={<i className="ic_mail" />}
        label={i18n["Page.PatientManagement.Profile.Invite"]}
        onClick={() => invitePatient(inviter)}
        additionalClass={"invite-link"}
      />
      {invitationState.loading && <LoadingSpinner />}
    </div>
  );
}
